module.exports = __webpack_public_path__ + "static/media/home-process-5.316c5f41.svg";